import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Loader EP/Rulantica :
 * - Pour Europa Park : alterne entre les loaders 1 et 2 à chaque rechargement de page
 * - Pour Rulantica : utilise exclusivement l'image ep-loading3.png
 * - Utilise localStorage pour une alternance persistante entre les sessions pour EP
 */
const EpRulanticaLoader = () => {
  const location = useLocation();
  const isRulantica = location.pathname.includes('rulantica');
  
  // État local pour l'alternance du loader Europa Park
  const [showFirst, setShowFirst] = useState(() => {
    // Initialisation à partir de la valeur courante dans localStorage
    const lastAlt = parseInt(localStorage.getItem('epRulanticaLoaderAlt') || '0', 10);
    return lastAlt === 0;
  });

  useEffect(() => {
    // Ne pas alterner pour Rulantica (image fixe)
    if (isRulantica) return;
    
    // Pour Europa Park : alterner à chaque rechargement ou navigation interne
    const lastAlt = parseInt(localStorage.getItem('epRulanticaLoaderAlt') || '0', 10);
    const nextAlt = lastAlt === 0 ? 1 : 0;
    localStorage.setItem('epRulanticaLoaderAlt', nextAlt);
    setShowFirst(nextAlt === 0);
  }, [isRulantica]);

  // Logique de sélection de l'image du loader
  const getLoaderImage = () => {
    // Pour Rulantica : toujours l'image 3
    if (isRulantica) {
      return "/images/ep-loading3.png";
    }
    
    // Pour Europa Park : alterner entre image 1 et 2
    return showFirst ? "/images/ep-loading1.png" : "/images/ep-loading2.png";
  };

  return (
    <div className="ep-rulantica-loading">
      <img
        src={getLoaderImage()}
        alt={isRulantica ? "Chargement Rulantica" : "Chargement Europa Park"}
        className="ep-rulantica-logo"
      />
    </div>
  );
};

export default EpRulanticaLoader;
